var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgListPic = function SvgListPic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.185 1.037v4.148H1.037V1.037h4.148m0-1.037H1.037A1.04 1.04 0 0 0 0 1.037v4.148c0 .57.467 1.037 1.037 1.037h4.148a1.04 1.04 0 0 0 1.037-1.037V1.037A1.04 1.04 0 0 0 5.185 0Zm7.778 1.037v4.148H8.815V1.037h4.148m0-1.037H8.815a1.04 1.04 0 0 0-1.037 1.037v4.148c0 .57.466 1.037 1.037 1.037h4.148A1.04 1.04 0 0 0 14 5.185V1.037A1.04 1.04 0 0 0 12.963 0ZM5.185 8.296v4.148H1.037V8.296h4.148m0-1.037H1.037A1.04 1.04 0 0 0 0 8.296v4.148c0 .57.467 1.037 1.037 1.037h4.148a1.04 1.04 0 0 0 1.037-1.037V8.296A1.04 1.04 0 0 0 5.185 7.26Zm3.111 5.704c-.31 0-.518-.207-.518-.519V8.296c0-.31.207-.518.518-.518.311 0 .519.207.519.518v4.148c0 .26-.26.519-.519.519Zm2.541 0c-.311 0-.518-.207-.518-.519V8.296c0-.31.207-.518.518-.518.311 0 .519.207.519.518v4.148c0 .26-.26.519-.519.519Zm2.644 0c-.31 0-.518-.207-.518-.519V8.296c0-.31.207-.518.518-.518.312 0 .519.207.519.518v4.148c0 .26-.26.519-.519.519Z",
    fill: "#333"
  })));
};

export default SvgListPic;